import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { divider } from "../../shared/styles";

export const StyledContent = styled(FlexColumn)`
    flex-grow: 1;
    min-height: 0;
`;

const StyledFooter = styled.div`
    ${divider};

    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
`;
